<template>
  <v-container class="col-12">
    <v-card class="pa-4">

      <v-row class="mt-0 mb-0 mr-0 ml-3 col-4 pa-0" style="max-width: 300px; float: right">
        <v-col class="pa-0 mt-1 ml-0 col-4">
          <span><v-icon :color="getStatusColor('pending')">mdi-pause</v-icon> pending</span><br />
          <span><v-icon :color="getStatusColor('open')">mdi-play</v-icon> open</span>
        </v-col>
        <v-col class="pa-0 mt-1 ml-0 col-4">
          <span><v-icon :color="getStatusColor('cashout')">mdi-account-cash-outline</v-icon> cashout</span><br />
          <span><v-icon :color="getStatusColor('rollback')">mdi-undo</v-icon> rollback</span>
        </v-col>
        <v-col class="pa-0 mt-1 ml-0 col-4">
          <span><v-icon :color="getStatusColor('lost')">mdi-stop</v-icon> lost</span><br />
          <span><v-icon :color="getStatusColor('won')">mdi-medal-outline</v-icon> won</span>
        </v-col>
      </v-row>

      <v-row class="mx-0 pa-0 col-12" style="max-width: 950px;">
        <v-select
          v-model="dateRange"
          :items="dateRangeList"
          label="Period"
          hide-details
          class="col-1"
          style="min-width: 250px"
        />
        <date-picker
          v-model="sportHistory.from"
          label="Date From"
          style="max-width: 240px"
          :show-time="true"
          :time-value="sportHistory.fromTime"
          @time-change="sportHistory.fromTime = $event"
        />
        <date-picker
          v-model="sportHistory.to"
          label="Date To"
          style="max-width: 240px"
          :show-time="true"
          :time-value="sportHistory.toTime"
          @time-change="sportHistory.toTime = $event"
        />

        <v-btn
          color="info"
          class="mt-3 ml-6"
          @click="search"
        >
          Search
        </v-btn>
      </v-row>
    </v-card>
    <v-card class="pa-4 mt-4">
      <v-data-table
        :headers="computedHeaders"
        :items="filteredItems"
        :loading="sportHistory.loading"
        :options.sync="sportHistory.options"
        sort-by="created"
        sort-asc
        dense
        fixed-header
        show-expand
        :expanded.sync="expanded"
        item-key="round_id"
        @update:page="stickyHeaders(350)"
        :footer-props="{'items-per-page-options': [1000]}"
        :items-per-page="1000"
        style="z-index: 0; position: relative;"
        class="sport-history-table"
      >
        <template v-slot:item.description="{ item }">
          <div
            v-for="r in item.description"
            :class="{'sport-event-description-item': $vuetify.breakpoint.name != 'xs' && $vuetify.breakpoint.name != 'sm', 'sport-event-description-item-mobile': $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'}"
          >
            <span>
              <template v-if="r.category_name">{{ r.category_name }} | </template>
              <template v-if="r.sport_name">{{ r.sport_name }} | </template>
              <template v-if="r.tournament_name">{{ r.tournament_name }} | </template>
              Market: {{ r.market_name }} |
              Outcome: {{ r.outcome_name }} (Odds: {{ r.odds }}) |
              {{ r.competitor_name.join(' - ') }}
              {{ r.competitor_name.length == 0 ? r.description : '' }}
            </span>
            <b>{{ r.status }}
              <v-icon :color="getStatusColor(r.status)">{{ getStatusIcon(r.status) }}</v-icon>
            </b>
          </div>
        </template>

        <template v-slot:item.round_id="{ item }">
          {{ item.round_id }}
          <v-btn
            v-if="$store.state.auth.checkAccess({key: 'discard_sportbet', value: true}) && (item.status === 'open' || item.status === 'pending')"
            icon
            small
            @click="discard(item)"
            class="float-right"
            title="Discard round"
            style="margin-top:  -5px;"
          >
            <v-icon small>mdi-undo-variant</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.status="{ item }">
          <b style="white-space: nowrap">
            <v-icon :color="getStatusColor(item.status)">{{ getStatusIcon(item.status) }}</v-icon>
            {{ item.status }}</b>
        </template>

        <template v-slot:item.created="{ item }">
          <span style="cursor: pointer" @click="copyToClipboard(item.created)">{{ item.created }}</span>
        </template>

        <template v-slot:item.finalized="{ item }">
          <span style="cursor: pointer" @click="copyToClipboard(item.finalized)">{{ item.finalized }}</span>
        </template>

        <template v-slot:expanded-item="{ headers , item }">
          <td :colspan="headers.length - 1" class="px-0 pt-0 pb-5">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th v-for="h of subHeaders" class="text-left">{{ h.text }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row of item.details">
                    <td v-for="h of subHeaders">

                      <template v-if="h.value != 'status'">{{ row[h.value] }}</template>
                      <template v-if="h.value == 'status'">
                        <v-icon :color="getStatusColor(row[h.value])">{{ getStatusIcon(row[h.value]) }}</v-icon>
                        {{ row[h.value] }}
                      </template>

                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </td>
          <td></td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style>

  .sport-history-table td:first-child {
    border-left: thin solid rgba(0, 0, 0, 0.12);
  }

  .sport-history-table th {
    white-space: nowrap;
  }

  .sport-history-table .sport-event-description-item-mobile,
  .sport-history-table .sport-event-description-item {
    padding: 5px 0;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
  }

  .sport-history-table .sport-event-description-item-mobile:last-child,
  .sport-history-table .sport-event-description-item:last-child {
    border-bottom: none;
  }

  .sport-history-table .sport-event-description-item span {
    display: inline-block;
    width: calc(100% - 105px)
  }

  .sport-history-table .sport-event-description-item b {
    float: right;
  }

  .sport-history-table .sport-event-description-item-mobile span {
    display: block;
  }

  .sport-history-table th,
  .sport-history-table td {
    padding: 5px 10px !important;
  }

  .sport-history-table td {
    border-right: thin solid rgba(0, 0, 0, 0.12);
  }

  .sport-history-table tr:last-child td {
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
  }

  .sport-history-table .sport-history-table-filter-row td {
    text-align: center;
    border-right: none;
    border-left: none;
    padding: 5px 3px !important;
  }

  .sport-history-table .sport-history-table-filter-row .v-input {
    margin: 0 auto !important;
  }

  .sport-history-table tbody tr.v-data-table__expanded__content {
    box-shadow: none;
  }

  .sport-history-table tbody tr.v-data-table__expanded__content > td {
    border: none;
  }

  .sport-history-table .v-data-footer > div:first-child {
    margin-left: auto;
  }

  .sport-history-table tbody tr.v-data-table__expanded__content td td:last-child,
  .sport-history-table tbody tr.v-data-table__expanded__content td th:last-child {
    border-right: thin solid rgba(0, 0, 0, 0.12);
  }

  .sport-history-table tbody tr.v-data-table__expanded__content td td:first-child,
  .sport-history-table tbody tr.v-data-table__expanded__content td th:first-child {
    border-left: thin solid rgba(0, 0, 0, 0.12);
  }

  .v-application--is-ltr .sport-history-table .v-data-table--fixed-header .v-data-footer {
    margin-right: 0;
  }
</style>

<script>
  import { mapGetters } from 'vuex'
  import 'sticky-table-headers'
  import { API } from '@/utils/api'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'
  import { makeDateRangeComputed } from '../utils'

  export default {
    components: {
      DatePicker
    },

    props: [],
    data: () => ({
      dateRangeList: global.dateRangeList,
      // transactions: [],
      expanded: [],
      subHeaders: [
        { text: 'Created', value: 'created' },
        { text: 'ID', value: 'id', sortable: true, align: 'left' },
        { text: 'ParentID', value: 'parent_id', sortable: true },
        { text: 'RoundID', value: 'round_id', sortable: true },
        { text: 'Amount', value: 'amount' },
        { text: 'Balance', value: 'balance' },
        { text: 'Bonus', value: 'bonus' },
        { text: 'Bonus Balance', value: 'bonus_balance' },
        { text: 'Rollover', value: 'rollover' },
        { text: 'Action', value: 'action' },
        { text: 'Status', value: 'status' },
      ],
      statusIconMap: {
        pending: 'mdi-pause',
        open: 'mdi-play',
        cashout: 'mdi-account-cash-outline',
        rollback: 'mdi-undo',
        lost: 'mdi-stop',
        won: 'mdi-medal-outline',
      },
      statusColorMap: {
        pending: 'gray',
        open: 'green',
        cashout: 'black',
        rollback: 'red',
        lost: 'red',
        won: 'green',
      }
    }),

    computed: {
      ...mapGetters({ activeAccount: 'account/active', sportHistory: 'account/sportHistory' }),
      filteredItems: function () {
        return this.sportHistory.items.filter(d => {
          return Object.keys(this.sportHistory.filters).every(f => {
            return this.sportHistory.filters[f].data.length < 1 || (this.sportHistory.filters[f].data.includes(d[f]) || (d[f] || '').toString().indexOf(this.sportHistory.filters[f].data) >= 0)
          })
        })
      },
      showBetOdds () {
        return this.filteredItems.some(row => row.system === 'betby')
      },
      computedHeaders () {
        const headers = [
          { text: 'Created', value: 'created' },
          { text: 'Finalized', value: 'finalized' },
          { text: 'RoundID', value: 'round_id', sortable: true, align: 'left' },
          { text: 'Description', value: 'description' },
          { text: 'Debit', value: 'debit' },
          { text: 'Credit', value: 'credit' },
          { text: 'Status', value: 'status' },
          { text: '', value: 'data-table-expand', 'class': 'nowrap' }
        ]

        if (this.showBetOdds) {
          headers.splice(3, 0, { text: 'Bet Odds', value: 'k' })
        }

        return headers
      },
      dateRange: makeDateRangeComputed('sportHistory'),
    },

    watch: {
      'sportHistory.options.page' (val) {
        if (window.pageYOffset > 250) {
          window.scrollTo(0, 250)
        }
      }
    },

    mounted () {
      this.stickyHeaders()
    },

    methods: {
      stickyHeaders () {
        global.jQuery('.sport-history-table table').stickyTableHeaders()
      },

      getStatusIcon (status) {
        return this.statusIconMap[status] || 'help-circle-outline'
      },
      getStatusColor (status) {
        return this.statusColorMap[status] || 'black'
      },


      copyToClipboard: function (text) {

        let el = document.createElement('textarea')
        el.value = text
        el.setAttribute('readonly', '')
        el.style = { position: 'absolute', left: '-9999px' }
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
      },

      search: function () {
        this.$store.dispatch('account/loadSportHistory', this.activeAccount.account).catch(e => {
          this.$notification.show = true
          this.$notification.message = e.response.data.message
          this.$notification.type = 'error'
        })
      },

      discard: async function (item) {
        if (!await this.$root.$confirm('Confirm', 'Discard RoundID: ' + item.round_id, { width: 400 }) || !this.$store.state.auth.checkAccess({ key: 'discard_sportbet', value: true })) return

        API.call('/$v/spin/discard.json', {
          account_id: this.activeAccount.account.account_id,
          round_id: item.round_id,
          system_id: item.system_id,
        }, this.activeAccount.account).then(resp => {
          this.$notification.show = true
          this.$notification.message = 'Request sent, it may take some time'
          this.$notification.type = 'success'
        }).catch(e => {
        })

      },

      columnValueList (val) {
        return this.sportHistory.items.map(d => d[val])
      },
    },
  }
</script>
